module.exports = __webpack_public_path__ + "static/media/orcid.f30e81a8.svg";